import { render } from "./ByihuseAccountHeader.vue?vue&type=template&id=380e489a&scoped=true&ts=true"
import script from "./ByihuseAccountHeader.vue?vue&type=script&lang=ts"
export * from "./ByihuseAccountHeader.vue?vue&type=script&lang=ts"

import "./ByihuseAccountHeader.vue?vue&type=style&index=0&id=380e489a&scoped=true&lang=css"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-380e489a"]])

export default __exports__